import React from "react";

import { makeStyles } from "@material-ui/core";
import Sandwich from "./sub-components/Sandwich";
import Pizza from "./sub-components/Pizza";
import Smoothies from "./sub-components/Smoothies";
import CreamCake from "./sub-components/CreamCake";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "0rem 0rem 1rem 0rem",
  },
}));

const ProductMenu = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <Sandwich />
      </div>
      <div className={classes.sectionContainer}>
        <Pizza />
      </div>
      <div className={classes.sectionContainer}>
        <Smoothies />
      </div>
      <div className={classes.sectionContainer}>
        <CreamCake />
      </div>
    </React.Fragment>
  );
};

export default ProductMenu;
